import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { selectCreateProjectSuccess } from '../../../../store/selectors/projects.selectors';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-projects-form',
  imports: [ReactiveFormsModule, CommonModule, ButtonModule],
  templateUrl: './projects-form.component.html',
  styleUrl: './projects-form.component.scss'
})
export class ProjectsFormComponent implements OnInit {
  @Output() formSubmit = new EventEmitter<any>();
  @Input() isEditMode: boolean = false;
  initialData = input<any | null>();
  private store = inject(Store);
  private messageService = inject(MessageService)
  projectForm!: FormGroup;

  constructor(private fb: FormBuilder) {

    this.projectForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    })
  }

  ngOnInit(): void {

    this.store.select(selectCreateProjectSuccess).subscribe(success => {
      if (success) {
        this.projectForm.reset();
        if (this.isEditMode) {
          this.messageService.add({ severity: 'success', summary: 'Project Updated', detail: 'Project has been updated successfully.' });
        }else {
          this.messageService.add({ severity: 'success', summary: 'Project Created', detail: 'Project has been created successfully.' });
        }
      }
    });
  }
  onSubmit(): void {
    if (this.projectForm.invalid) {
      this.projectForm.markAllAsTouched();
      return;
    }
    this.formSubmit.emit(this.projectForm.value);
  }
}
